// import Axios from 'axios'

export default {

  connectByType(type, id, satellite, model) {
    // TODO: remove
    return env.API.post('/satellite/connectField', {type: type, fieldId: id, satellite: satellite, model: model});
  },
  fetchAll(type, id, satellite, model) {
    return env.API.post(`/satellite/${type}/fetchAll`, {fieldId: id, satellite: satellite, model: model});
  },
  connectField(id, crop, area) {
    return env.API.post('/satellite/connectField', {fieldId: id, crop: crop, area: area});
  },
  connectByConfiguration(type, id, satellite, model) {
    return env.API.post(`/satellite/${type}/subscribe`, {model: model, fieldId: id, satellite: satellite});
  },
  checkStatus(type, id, satellite, model) {
    return env.API.post(`/satellite/${type}/checkStatus`, {model: model, fieldId: id, satellite: satellite});
  },
  buy(hectars, pm) {

    return env.API.post(`/satellite/buy`, {
      hectars: hectars,
      pm,
    });
  },
  connectNitrogen(fieldId, nitrogen) {
    return env.API.post('/satellite/nitrogen/subscribe', {fieldId: fieldId, nitrogen: nitrogen});
  },
  getNitrogenColorscale(link) {
    return env.API.post('satellite/getFile', {link: link});
  },
  getTimeSeries(id, satellite) {
    return env.API.post(`satellite/plantHealth/getTimeSeries`, { fieldId: id, satellite: satellite });
  },

}
